import { SET_OPEN_ORDERS, SET_ORDER_HISTORY, SET_FETCH_OPENORDERS } from './action'

const initialState = {
  openOrders: {},
  orderHistory: {},
  isFetchOpenOrders: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_OPEN_ORDERS:
      return {
        ...state,
        openOrders: action.data,
      }

    case SET_ORDER_HISTORY:
      return {
        ...state,
        orderHistory: action.data,
      }

    case SET_FETCH_OPENORDERS:
      return {
        ...state,
        isFetchOpenOrders: action.data,
      }

    default:
      return state
  }
}
